var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#007BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5952_3784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.15 24.5C10.15 16.8632 16.3632 10.65 24 10.65C31.6368 10.65 37.85 16.8632 37.85 24.5C37.85 32.1368 31.6368 38.35 24 38.35C16.3632 38.35 10.15 32.1368 10.15 24.5ZM12.3955 24.5C12.3955 30.8989 17.601 36.1045 24 36.1045C30.3989 36.1045 35.6045 30.8989 35.6045 24.5C35.6045 18.1011 30.399 12.8955 24 12.8955C17.601 12.8955 12.3955 18.1011 12.3955 24.5Z",
    fill: "white",
    stroke: "#007BFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.057 23.5558C17.057 23.5558 17.057 23.5558 17.057 23.5558C17.4954 23.1174 18.2063 23.1175 18.6447 23.5559L21.9445 26.8557L22.0506 26.9618L22.1566 26.8557L29.3564 19.6561C29.7948 19.2176 30.5056 19.2177 30.9441 19.6561C31.3826 20.0946 31.3826 20.8054 30.9441 21.2439L22.8444 29.3434C22.6338 29.5539 22.3483 29.6723 22.0506 29.6723H22.0505C21.7527 29.6723 21.4672 29.5539 21.2566 29.3434L17.057 25.1435L16.9509 25.2496M17.057 23.5558L16.9509 23.4497C16.4539 23.9467 16.4539 24.7526 16.9509 25.2496M17.057 23.5558C16.6185 23.9942 16.6185 24.7051 17.057 25.1435L16.9509 25.2496M17.057 23.5558L16.9509 25.2496",
    fill: "white",
    stroke: "#007BFF",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5952_3784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIcon);
export default __webpack_public_path__ + "static/media/applied_icon.755c7d03ad175e06289438f5e8b0ea92.svg";
export { ForwardRef as ReactComponent };